module.exports = __webpack_public_path__ + "img/max-file-transfer--excel.3bbf7f75.svg";